let configStore = {
  events: {},
};

function set(newValuesObject: any) {
  configStore = Object.assign({}, configStore, newValuesObject);
}

function get(key: any) {
  return key ? (configStore as any)[key] : configStore;
}

export { get, set };
